Vendd.Scripts.load(function () {

    var $wrapper = $('.x-category-list-menu');

    if ($wrapper.length < 1)
        return;

    var wrapper = $wrapper.get(0);

    var iconOpen = $wrapper.data('open-icon');
    var iconClose = $wrapper.data('close-icon');

    var stickyCatMenu = function () {
        var catMenu = $('.x-category-list-menu');
        var catMenuHeight = catMenu.height();
        var spacer = $('.cat-menu-spacer');
    
        var lastScrollTop = 0;
        var delta = 5;
        var stickyNavTop = $('.x-category-list-menu').offset().top;
        $(window).scroll($.throttle(100, initSticky));

        function initSticky() {
            var st = $(this).scrollTop();
            // Make sure they scroll more than delta
            if (Math.abs(lastScrollTop - st) <= delta)
                return;

            if($(window).outerWidth() >= 1200){
                if ($(window).scrollTop() <= stickyNavTop) {
                    catMenu.removeClass('sticky-menu');
                    spacer.height(0);

                 //   $('.header-template-one').show();
                } else {
                    catMenu.addClass('sticky-menu');
                    spacer.height(catMenuHeight);
                //    $('.header-template-one').hide();
                }
            } else{
                catMenu.removeClass('sticky-menu');
                spacer.height(0);
                if(!isTouch()){
             //       $('.header-template-one').show();
                }
            }

            lastScrollTop = st;
        }
    }

    var initStickyBtn = function () {
        $(window).scroll(function(){
            if($(window).outerWidth() < 1200){
                if($(this).scrollTop() > $wrapper.offset().top + $wrapper.height()) {
                    $('.sticky-menu-btn').addClass('scrolled');
            //        $('.header-template-one').hide();
                } else {
                    $('.sticky-menu-btn').removeClass('scrolled');
           //         $('.header-template-one').show();
                }
            } else {
                $('.sticky-menu-btn').removeClass('scrolled');
            }
        });

        $('.sticky-menu-btn').on('click', function(){
            $('html, body').animate({scrollTop: $wrapper.offset().top - $('.header-spacer').height()}, 1);
            wrapper.open(); 
        })
    }

    stickyCatMenu();

    if(isTouch()){
        initStickyBtn();
    }
    
    $wrapper.on('click', '.mobile-title', function (e) {
        e.preventDefault();

        var $this = $(this);

        if ($this.hasClass('active')) {
            wrapper.close();
        } else {
            wrapper.open();
        }
    });

    wrapper.open = function () {
        $('.mobile-title', $wrapper).addClass('active');
        $('.mobile-title > .title', $wrapper).toggleClass(iconOpen + " " + iconClose);
        $('.nav-1', $wrapper).addClass('active');
    };

    wrapper.close = function () {
        $('.mobile-title', $wrapper).removeClass('active');
        $('.mobile-title > .title', $wrapper).toggleClass(iconOpen + " " + iconClose);
        $('.nav-1', $wrapper).removeClass('active');
    };

    $("[class^='category-']", $wrapper).on('click', function(e){
        var id ='#' + $(this).data('anchor');
        var anchor = $(id);
        
        if(!$(this).hasClass('selected')) {
            $("[class^='category-']", $wrapper).removeClass("selected");
            $(this).addClass('selected');

        } 

        $('html, body').animate({
            scrollTop: anchor.offset().top - 70
        }, 1000);
    }); 
});

